import { CombinedState } from '@reduxjs/toolkit';
import { RootStateType } from 'App/store';
import { convertStatusTypeToObject } from 'commons/utils/convertStatusTypeToObject';
import createSimpleSelector from 'commons/utils/createSimpleSelector';
import { CustomerPriceTablesInterface } from '../types';

export const getCustomerPriceTablesState = (
  state: RootStateType,
): CombinedState<CustomerPriceTablesInterface> =>
  state.customers.customerPriceTables;

export const getCustomerPriceTablesData = createSimpleSelector(
  [getCustomerPriceTablesState],
  (state) => state.priceTables.data,
);

export const getCustomerPriceTablesStatus = createSimpleSelector(
  [getCustomerPriceTablesState],
  (state) => convertStatusTypeToObject(state.priceTables.status),
);
